// Traducciones de /seguridad. Los nombres propios (Google Cloud, OpenAI, Anthropic, etc.) se mantienen;
// cada entrada es [es, en, pt-BR].
export const seguridadMessages = Object.fromEntries(
  [
    // Encabezado
    ['SEGURIDAD', 'SECURITY', 'SEGURANÇA'],
    ['Datos, accesos y proveedores', 'Data, access and providers', 'Dados, acessos e fornecedores'],
    ['Cómo cuidamos ', 'How we protect ', 'Como cuidamos '],
    ['los datos de tu empresa.', 'your company’s data.', 'os dados da sua empresa.'],
    [
      'Dónde están tus datos, quién accede y a qué proveedores llegan. Lo que tu equipo necesita para una revisión de proveedor, en una sola página.',
      'Where your data is, who can access it and which providers receive it. What your team needs for a vendor review, on a single page.',
      'Onde estão seus dados, quem acessa e a quais fornecedores chegam. O que sua equipe precisa para uma avaliação de fornecedor, em uma única página.',
    ],
    ['Ver proveedores', 'See providers', 'Ver fornecedores'],
    ['Reportar una vulnerabilidad', 'Report a vulnerability', 'Reportar uma vulnerabilidade'],
    ['Infraestructura certificada', 'Certified infrastructure', 'Infraestrutura certificada'],
    ['Datos de cada empresa', 'Each company’s data', 'Dados de cada empresa'],
    ['Aislados', 'Isolated', 'Isolados'],
    ['Cada empresa ve solo sus datos', 'Each company sees only its own data', 'Cada empresa vê apenas seus dados'],
    ['Proveedores', 'Providers', 'Fornecedores'],
    ['Lista pública', 'Public list', 'Lista pública'],
    ['Por categoría, en esta página', 'By category, on this page', 'Por categoria, nesta página'],
    ['Servidor MCP', 'MCP server', 'Servidor MCP'],
    ['Por token', 'Per token', 'Por token'],
    ['Permisos de lectura o de edición', 'Read or edit permissions', 'Permissões de leitura ou de edição'],
    // 01 · Infraestructura
    ['01 / Infraestructura', '01 / Infrastructure', '01 / Infraestrutura'],
    ['Tus datos, en ', 'Your data, on ', 'Seus dados, no '],
    ['Google Cloud.', 'Google Cloud.', 'Google Cloud.'],
    [
      'Operamos sobre la infraestructura de Google Cloud, con sus certificaciones SOC 2 e ISO 27001 y su cifrado.',
      'We run on Google Cloud infrastructure, with its SOC 2 and ISO 27001 certifications and its encryption.',
      'Operamos sobre a infraestrutura do Google Cloud, com suas certificações SOC 2 e ISO 27001 e sua criptografia.',
    ],
    ['Ubicación', 'Location', 'Localização'],
    ['Tus datos en Google Cloud (EE. UU.)', 'Your data on Google Cloud (US)', 'Seus dados no Google Cloud (EUA)'],
    [
      'La plataforma, la base de datos y las copias de seguridad están en Google Cloud, en Estados Unidos.',
      'The platform, the database and the backups are on Google Cloud, in the United States.',
      'A plataforma, o banco de dados e os backups estão no Google Cloud, nos Estados Unidos.',
    ],
    ['Cifrado', 'Encryption', 'Criptografia'],
    ['En tránsito y en reposo', 'In transit and at rest', 'Em trânsito e em repouso'],
    [
      'Las conexiones al sitio y a la plataforma usan TLS. Los datos guardados se cifran en reposo con AES-256.',
      'Connections to the site and the platform use TLS. Stored data is encrypted at rest with AES-256.',
      'As conexões com o site e a plataforma usam TLS. Os dados armazenados são criptografados em repouso com AES-256.',
    ],
    ['Respaldo', 'Backups', 'Backup'],
    ['Copias diarias y semanales', 'Daily and weekly copies', 'Cópias diárias e semanais'],
    [
      'Una copia diaria que se guarda 14 días y una semanal que se guarda 60. La base de datos, además, se puede recuperar a su estado de cualquiera de los últimos 7 días.',
      'A daily copy kept for 14 days and a weekly one kept for 60. The database can also be restored to its state on any of the last 7 days.',
      'Uma cópia diária guardada por 14 dias e uma semanal guardada por 60. Além disso, o banco de dados pode ser restaurado ao estado de qualquer um dos últimos 7 dias.',
    ],
    // 02 · Acceso
    ['02 / Acceso', '02 / Access', '02 / Acesso'],
    ['Cada empresa ', 'Each company ', 'Cada empresa '],
    ['ve solo sus datos.', 'sees only its own data.', 'vê apenas seus dados.'],
    [
      'Tu equipo entra con sus propias cuentas y cada persona tiene uno de cuatro roles. Nadie de otra empresa ve tu información.',
      'Your team signs in with their own accounts and each person has one of four roles. No one from another company sees your information.',
      'Sua equipe entra com as próprias contas e cada pessoa tem uma de quatro funções. Ninguém de outra empresa vê suas informações.',
    ],
    ['Propietario', 'Owner', 'Proprietário'],
    ['Administra la empresa y no se puede quitar.', 'Manages the company and cannot be removed.', 'Administra a empresa e não pode ser removido.'],
    ['Administrador', 'Admin', 'Administrador'],
    [
      'Suma y quita miembros, y crea y revoca los tokens del servidor MCP.',
      'Adds and removes members, and creates and revokes MCP server tokens.',
      'Adiciona e remove membros, e cria e revoga os tokens do servidor MCP.',
    ],
    ['Editor', 'Editor', 'Editor'],
    ['Cambia los datos de la empresa en la plataforma.', 'Changes the company’s data in the platform.', 'Altera os dados da empresa na plataforma.'],
    ['Lector', 'Viewer', 'Leitor'],
    ['Ve todo lo de su empresa, sin cambiar nada.', 'Sees everything in their company, without changing anything.', 'Vê tudo da sua empresa, sem alterar nada.'],
    ['Inicio de sesión', 'Sign-in', 'Login'],
    [
      'El acceso es con tu cuenta de Google; activa en ella la verificación en dos pasos. También puedes entrar con correo y contraseña, con el correo verificado.',
      'Access is with your Google account; turn on 2-Step Verification in it. You can also sign in with email and password, with a verified email.',
      'O acesso é com sua conta do Google; ative nela a verificação em duas etapas. Você também pode entrar com e-mail e senha, com o e-mail verificado.',
    ],
    ['Invitaciones', 'Invitations', 'Convites'],
    [
      'Los miembros nuevos entran con un enlace de invitación propio, que vence a las 24 horas.',
      'New members join with their own invitation link, which expires after 24 hours.',
      'Novos membros entram com um link de convite próprio, que expira em 24 horas.',
    ],
    ['Personal de Bison', 'Bison staff', 'Equipe da Bison'],
    [
      'Solo personal autorizado de Bison accede, y solo para soporte.',
      'Only authorized Bison staff have access, and only for support.',
      'Somente pessoal autorizado da Bison acessa, e somente para suporte.',
    ],
    // 03 · Servidor MCP
    ['03 / Servidor MCP', '03 / MCP server', '03 / Servidor MCP'],
    ['Tu asistente entra ', 'Your assistant connects ', 'Seu assistente entra '],
    ['con un token, no con tu usuario.', 'with a token, not with your user.', 'com um token, não com seu usuário.'],
    [
      'Si conectas un asistente de IA a Bison, cada conexión usa un token que crea un administrador de tu empresa.',
      'If you connect an AI assistant to Bison, each connection uses a token created by an admin of your company.',
      'Se você conectar um assistente de IA à Bison, cada conexão usa um token criado por um administrador da sua empresa.',
    ],
    ['Por empresa', 'Per company', 'Por empresa'],
    [
      'Cada token pertenece a una empresa y solo ve los datos de esa empresa.',
      'Each token belongs to one company and sees only that company’s data.',
      'Cada token pertence a uma empresa e vê apenas os dados dessa empresa.',
    ],
    ['Lectura o edición', 'Read or edit', 'Leitura ou edição'],
    [
      'Todo token puede leer. Las herramientas que cambian datos solo se activan si el token se creó con permiso de edición.',
      'Every token can read. Tools that change data are enabled only if the token was created with edit permission.',
      'Todo token pode ler. As ferramentas que alteram dados só são ativadas se o token foi criado com permissão de edição.',
    ],
    ['Se muestra una vez', 'Shown once', 'Exibido uma vez'],
    [
      'Lo ves solo al crearlo. Guardamos su huella, no el token.',
      'You see it only when you create it. We store its fingerprint, not the token.',
      'Você o vê apenas ao criá-lo. Guardamos sua impressão digital, não o token.',
    ],
    ['Revocable', 'Revocable', 'Revogável'],
    [
      'Un administrador lo revoca y deja de aceptarse desde la siguiente llamada.',
      'An admin revokes it and it stops being accepted from the next call.',
      'Um administrador o revoga e ele deixa de ser aceito a partir da chamada seguinte.',
    ],
    ['Ver permisos del servidor MCP', 'See MCP server permissions', 'Ver permissões do servidor MCP'],
    // 04 · Datos
    ['04 / Datos', '04 / Data', '04 / Dados'],
    ['Qué guardamos ', 'What we store ', 'O que guardamos '],
    ['y por cuánto tiempo.', 'and for how long.', 'e por quanto tempo.'],
    [
      'Lo necesario para medir y mostrar la visibilidad de tu marca en IA.',
      'What is needed to measure and show your brand’s visibility in AI.',
      'O necessário para medir e mostrar a visibilidade da sua marca na IA.',
    ],
    ['Lo que guardamos', 'What we store', 'O que guardamos'],
    ['Cuánto tiempo', 'How long', 'Por quanto tempo'],
    ['Cuenta', 'Account', 'Conta'],
    [
      'Datos de la empresa y de sus miembros, y el perfil de marca que completas.',
      'Company and member data, and the brand profile you fill in.',
      'Dados da empresa e de seus membros, e o perfil de marca que você preenche.',
    ],
    ['Medición', 'Measurement', 'Medição'],
    [
      'Las preguntas que monitoreas, las respuestas de los motores de IA, los reportes y las mejoras sugeridas.',
      'The questions you monitor, the AI engines’ answers, the reports and the suggested improvements.',
      'As perguntas que você monitora, as respostas dos motores de IA, os relatórios e as melhorias sugeridas.',
    ],
    ['Integraciones', 'Integrations', 'Integrações'],
    [
      'Si conectas tus cuentas de Google, como Analytics o Search Console, leemos esos datos con los permisos que concedes.',
      'If you connect your Google accounts, such as Analytics or Search Console, we read that data with the permissions you grant.',
      'Se você conectar suas contas do Google, como Analytics ou Search Console, lemos esses dados com as permissões que você concede.',
    ],
    ['Facturación', 'Billing', 'Faturamento'],
    ['Suscripción, pagos y facturas.', 'Subscription, payments and invoices.', 'Assinatura, pagamentos e faturas.'],
    ['Copias de seguridad', 'Backups', 'Backups'],
    ['14 días la copia diaria y 60 días la semanal.', '14 days for the daily copy and 60 days for the weekly one.', '14 dias a cópia diária e 60 dias a semanal.'],
    ['Al terminar el contrato', 'When the contract ends', 'Ao término do contrato'],
    [
      'Lo fijan los Términos y Condiciones, cláusula 9.1.',
      'It is set by the Terms and Conditions, clause 9.1.',
      'É definido pelos Termos e Condições, cláusula 9.1.',
    ],
    ['Ver los Términos y Condiciones', 'See the Terms and Conditions', 'Ver os Termos e Condições'],
    ['Eliminar una empresa', 'Deleting a company', 'Excluir uma empresa'],
    ['Se pide al equipo de Bison, que la elimina.', 'You ask the Bison team, and they delete it.', 'Você pede à equipe da Bison, que a exclui.'],
    // 05 · Proveedores
    ['05 / Proveedores', '05 / Providers', '05 / Fornecedores'],
    ['Con quién trabajamos ', 'Who we work with ', 'Com quem trabalhamos '],
    ['y qué recibe cada uno.', 'and what each one receives.', 'e o que cada um recebe.'],
    [
      'Los proveedores que reciben datos para que la plataforma funcione, por categoría.',
      'The providers that receive data so the platform works, by category.',
      'Os fornecedores que recebem dados para que a plataforma funcione, por categoria.',
    ],
    ['Categoría', 'Category', 'Categoria'],
    ['Qué recibe', 'What it receives', 'O que recebe'],
    ['Infraestructura', 'Infrastructure', 'Infraestrutura'],
    ['Los datos de la plataforma', 'The platform’s data', 'Os dados da plataforma'],
    ['Modelos de IA de terceros', 'Third-party AI models', 'Modelos de IA de terceiros'],
    [
      'Las preguntas que monitoreas y, para entender tu negocio, la URL pública de tu sitio',
      'The questions you monitor and, to understand your business, your site’s public URL',
      'As perguntas que você monitora e, para entender seu negócio, a URL pública do seu site',
    ],
    ['Proveedores de datos de búsqueda', 'Search data providers', 'Fornecedores de dados de busca'],
    ['Detalle a pedido', 'Details on request', 'Detalhes sob pedido'],
    ['El texto de las preguntas y el país de la medición', 'The text of the questions and the country measured', 'O texto das perguntas e o país da medição'],
    [
      'Lista completa de proveedores y anexo técnico: a pedido.',
      'Full provider list and technical annex: on request.',
      'Lista completa de fornecedores e anexo técnico: sob pedido.',
    ],
    [
      'En este sitio, la analítica y la medición de campañas solo se activan si aceptas las cookies.',
      'On this site, analytics and campaign measurement are enabled only if you accept cookies.',
      'Neste site, a análise e a medição de campanhas só são ativadas se você aceitar os cookies.',
    ],
    ['Ver la Política de Privacidad', 'See the Privacy Policy', 'Ver a Política de Privacidade'],
    [
      'No usamos los datos de nuestros clientes para entrenar modelos de IA.',
      'We do not use our customers’ data to train AI models.',
      'Não usamos os dados dos nossos clientes para treinar modelos de IA.',
    ],
    // 06 · Cumplimiento
    ['06 / Cumplimiento', '06 / Compliance', '06 / Conformidade'],
    ['Lo que pide ', 'What a vendor review ', 'O que pede '],
    ['una revisión de proveedor.', 'asks for.', 'uma avaliação de fornecedor.'],
    [
      'Certificaciones, ley aplicable, incidentes y contratos.',
      'Certifications, applicable law, incidents and contracts.',
      'Certificações, lei aplicável, incidentes e contratos.',
    ],
    ['Certificaciones', 'Certifications', 'Certificações'],
    [
      'Bison todavía no tiene una certificación propia; todos nuestros servicios operan sobre Google Cloud, que sí la tiene: SOC 2 e ISO 27001.',
      'Bison does not yet have its own certification; all our services run on Google Cloud, which does: SOC 2 and ISO 27001.',
      'A Bison ainda não tem uma certificação própria; todos os nossos serviços operam sobre o Google Cloud, que tem: SOC 2 e ISO 27001.',
    ],
    ['Datos personales', 'Personal data', 'Dados pessoais'],
    [
      'Hoy rige la Ley 19.628. La Ley 21.719, con reglas para notificar vulneraciones de seguridad, tiene vigencia prevista para el 1 de diciembre de 2026.',
      'Chile’s Law 19,628 applies today. Law 21,719, with rules for notifying security breaches, is expected to take effect on December 1, 2026.',
      'Hoje vigora a Lei 19.628 do Chile. A Lei 21.719, com regras para notificar violações de segurança, tem vigência prevista para 1º de dezembro de 2026.',
    ],
    ['Incidentes', 'Incidents', 'Incidentes'],
    [
      'Si un incidente afecta datos personales, avisamos a las personas afectadas y a la autoridad dentro de los plazos que fije la ley.',
      'If an incident affects personal data, we notify the people affected and the authority within the deadlines set by law.',
      'Se um incidente afetar dados pessoais, avisamos as pessoas afetadas e a autoridade dentro dos prazos que a lei fixar.',
    ],
    ['Revisión de proveedor', 'Vendor review', 'Avaliação de fornecedor'],
    [
      'Para un cuestionario de seguridad, un DPA o un NDA, escríbenos a security@bisonagents.com.',
      'For a security questionnaire, a DPA or an NDA, write to us at security@bisonagents.com.',
      'Para um questionário de segurança, um DPA ou um NDA, escreva para security@bisonagents.com.',
    ],
    // 07 · Divulgación responsable
    ['07 / Divulgación responsable', '07 / Responsible disclosure', '07 / Divulgação responsável'],
    ['¿Encontraste ', 'Did you find ', 'Encontrou '],
    ['una vulnerabilidad?', 'a vulnerability?', 'uma vulnerabilidade?'],
    [
      'Escríbenos a security@bisonagents.com antes de hacerla pública y la revisamos contigo.',
      'Write to us at security@bisonagents.com before making it public and we will review it with you.',
      'Escreva para security@bisonagents.com antes de torná-la pública e a revisamos com você.',
    ],
    ['Reporte', 'Report', 'Relato'],
    ['Dónde aplica', 'Where it applies', 'Onde se aplica'],
    ['Para reportes y revisiones de seguridad.', 'For security reports and reviews.', 'Para relatos e avaliações de segurança.'],
    [
      'El detalle sobre datos personales está en la Política de Privacidad.',
      'The details on personal data are in the Privacy Policy.',
      'O detalhe sobre dados pessoais está na Política de Privacidade.',
    ],
    ['Qué incluir', 'What to include', 'O que incluir'],
    [
      'Qué encontraste, cómo reproducirlo y qué datos viste. Si es posible, sin acceder a datos de otros clientes ni afectar el servicio.',
      'What you found, how to reproduce it and what data you saw. If possible, without accessing other customers’ data or affecting the service.',
      'O que você encontrou, como reproduzir e quais dados viu. Se possível, sem acessar dados de outros clientes nem afetar o serviço.',
    ],
    ['Alcance', 'Scope', 'Escopo'],
    ['bisonagents.com, la plataforma y el servidor MCP.', 'bisonagents.com, the platform and the MCP server.', 'bisonagents.com, a plataforma e o servidor MCP.'],
    ['security.txt', 'security.txt', 'security.txt'],
    [
      'El archivo security.txt de bisonagents.com trae el mismo contacto.',
      'The security.txt file on bisonagents.com has the same contact.',
      'O arquivo security.txt de bisonagents.com traz o mesmo contato.',
    ],
    ['Ver security.txt', 'See security.txt', 'Ver security.txt'],
    ['Responsable de datos:', 'Data protection contact:', 'Responsável pelos dados:'],
    // Llamado final
    ['Mira la plataforma por dentro, ', 'See the platform from the inside, ', 'Veja a plataforma por dentro, '],
    ['con tu equipo.', 'with your team.', 'com sua equipe.'],
    // Footer
    ['Seguridad', 'Security', 'Segurança'],
    ['Ver la página de seguridad', 'See the security page', 'Ver a página de segurança'],
  ].map(([es, ...traducciones]) => [es, traducciones]),
);
